import GeomPoint from 'ol/geom/Point';
import GeomLineString from 'ol/geom/LineString';
const TEXT_OFFSET = 12;
const RIGHT_ANGLE = Math.PI / 2; // radians, (90 deg)
const getRotation = (startCoord, endCoord) => {
    const dx = endCoord[0] - startCoord[0];
    const dy = endCoord[1] - startCoord[1];
    return Math.atan2(dy, dx);
};
const getMiddleCoordinate = (startCoord, endCoord) => {
    // get middle coord between two coords
    const segment = new GeomLineString([startCoord, endCoord]);
    return segment.getCoordinateAt(0.5);
};
export const getCommonRotateData = (startCoord, endCoord) => {
    let rotation = 0;
    // get Rotation
    rotation = getRotation(startCoord, endCoord);
    // get middle coordinate
    const coordinate = getMiddleCoordinate(startCoord, endCoord);
    return {
        rotation,
        coordinate,
    };
};
export const adjustRotateData = (rotation, point, resolution) => {
    // get offseted coordinate
    const coordinate = offsetCoordinate(point, rotation - Math.PI / 2, resolution);
    // rotate text about 360 by quadrant
    if (rotation > RIGHT_ANGLE) {
        rotation += Math.PI;
    }
    else if (rotation < -RIGHT_ANGLE && rotation > -Math.PI) {
        rotation -= Math.PI;
    }
    return {
        point: new GeomPoint(coordinate),
        rotation: -rotation,
    };
};
export const offsetCoordinate = (coordinate, angle, resolution) => {
    const offset = resolution * TEXT_OFFSET;
    const x = coordinate[0] + Math.cos(angle) * offset;
    const y = coordinate[1] + Math.sin(angle) * offset;
    return [x, y];
};
//# sourceMappingURL=rotateText.js.map